"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a STREAM_ADD_TOPIC_SERVICE request.
 */
var UpdateStreamAddTopicRequest = /** @class */ (function () {
    /**
     * Create a new UpdateStreamAddTopicRequest instance
     *
     * @param path  the topic path
     * @param topicSpecification  the topic specification
     * @param constraint  the update constraint
     */
    function UpdateStreamAddTopicRequest(path, topicSpecification, constraint) {
        this.path = path;
        this.topicSpecification = topicSpecification;
        this.constraint = constraint;
    }
    return UpdateStreamAddTopicRequest;
}());
exports.UpdateStreamAddTopicRequest = UpdateStreamAddTopicRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-add-topic-request.js
// module id = 2067
// module chunks = 1